import { Fragment } from 'react'
import { FormattedMessage } from 'react-intl'
import RatingStars from '../helpers/RatingStars'

export default function DiverRatingButton({ rating, numberOfReviews }) {
  return (
    <Fragment>
      <div className='title'>
        <FormattedMessage id='diver_rating' defaultMessage='Diver Ratings' />
      </div>
      <div className={`rating-wrap ${!numberOfReviews ? 'no-rating' : ''}`}>
        <RatingStars rating={rating} />
        <span className='reviews-qty'>
          <FormattedMessage id='reviews_plural'
            values={{ qty: numberOfReviews }}
            defaultMessage='{qty, plural, one {# review} other {# reviews}}' />
        </span>
      </div>
    </Fragment>)
}

